import React, { useContext } from 'react';
import { Context } from 'store';
import moment from 'moment';
import { Tooltip } from 'antd';
import { MaskRestrictedText } from '_src/components';
import holidayIcon from '_src/assets/images/palm-tree.png';

const fmt = 'HH:mm';
const Location = ({ branchId, locationType }) => {
  const { getData } = useContext(Context);
  const locations = getData('locations') || [];
  const location = locations.find(loc => branchId === loc.branchId && locationType === loc.type);

  return location ? location.label : '';
};

export default [
  {
    title: 'Student',
    dataIndex: 'name',
    render: (name, { isPublicHoliday, locationType, classSubmittedToFmsca }) => {
      return (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{ cursor: 'pointer', textDecoration: 'underline' }}>{name}</div>
          {isPublicHoliday && locationType === 1 && !classSubmittedToFmsca && (
            <Tooltip title="This student was moved to yard for a Holiday and must still complete theory.">
              <img src={holidayIcon} style={{ height: 19, width: 19 }} />
            </Tooltip>
          )}
        </div>
      );
    }
  },
  {
    title: 'Sponsor',
    dataIndex: 'sponsor',
    render: _ => <MaskRestrictedText text={_} />
  },
  {
    title: 'Location',
    dataIndex: 'location',
    render: (_, { branchId, locationType }) => (
      <Location branchId={branchId} locationType={locationType} />
    )
  },
  {
    id: 'sessions',
    title: 'Sessions',
    dataIndex: 'attendances',
    render: (sessions, { absent }) => {
      if (absent) {
        const { isExcused } = absent;
        return (
          <div style={{ cursor: 'pointer', textDecoration: 'underline' }}>
            Absent {isExcused ? '' : 'un'}excused
          </div>
        );
      }

      return (
        <div style={{ cursor: 'pointer', textDecoration: 'underline' }}>
          {sessions.length === 0 && <div>No attendance</div>}
          {sessions.map(({ id, checkIn, checkOut, isLate }) => (
            <div key={id}>
              {checkIn ? (
                <span style={{ color: isLate ? GLOBALS.colors.RED : undefined }}>
                  {moment.parseZone(checkIn).format(fmt)}
                </span>
              ) : (
                ''
              )}{' '}
              - {checkOut ? moment.parseZone(checkOut).format(fmt) : ''}
            </div>
          ))}
        </div>
      );
    }
  }
];
